module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMSIgaGVpZ2h0PSIxNyIgdmlld0JveD0iMCAwIDExIDE3Ij4KICAgIDxwYXRoIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlPSIjRkZGIiBzdHJva2Utd2lkdGg9IjIiIGQ9Ik0xLjU0NCAxLjA1TDguOTY2IDguNWwtNy40MjIgNy40NSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./static/img/arrow-icon.svg
// module id = UOb7
// module chunks = 0 1 2 5 6